import React, {FC} from "react";
import {Button} from "primereact/button";
import {PrimeIcons} from "primereact/api";
import {ConfirmDialog} from "primereact/confirmdialog";
import {
    useCompleteReplacementRequestMutation,
    useFindReplacementResponsesByReplacementRequestIdQuery
} from "../../api/refereeReplacementApi";
import {Dialog} from "primereact/dialog";

const Actions: FC<{ row: any }> = ({row}) => {
    const [visibleApproved, setVisibleApproved] = React.useState(false);
    const [visibleResponses, setVisibleResponses] = React.useState(false);

    const [completeReplacementRequest] = useCompleteReplacementRequestMutation();

    const {data = [], isLoading} = useFindReplacementResponsesByReplacementRequestIdQuery({replacementRequestId: row.id});

    return (
        <>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: 10}}>
                <Button label={data?.length + ""} severity={data?.length === 0 ? "danger" : data?.length === 1 ? "warning" : "success" } title="Pokaż zgłoszonych na mecz"
                        tooltip="Pokaż zgłoszonych na mecz" tooltipOptions={{position: "left"}} style={{width: 70, textAlign: "center"}}
                        onClick={() => setVisibleResponses(true)}/>
                <Dialog
                    visible={visibleResponses}
                    header="Zgłoszenia"
                    headerStyle={{paddingRight: 10}}
                    onHide={() => {
                        setVisibleResponses(false);
                    }}
                    dismissableMask={true}
                >
                    {isLoading && "Ładowanie danych..."}
                    {!isLoading && data.length !== 0 && data.map((item) => {
                        return <div>• {item.refereeFullName}</div>
                    })}
                    {!isLoading && data.length === 0 && "Brak zgłoszeń"}
                </Dialog>
                <Button icon={PrimeIcons.CHECK_CIRCLE} severity="success" title="Potwierdź zmianę"
                        tooltip="Potwierdź dokonaną zmianę" tooltipOptions={{position: "left"}}
                        onClick={() => setVisibleApproved(true)}/>
                <ConfirmDialog
                    visible={visibleApproved}
                    onHide={() => setVisibleApproved(false)}
                    message="Jesteś pewny, że zastępstwo zostało dokonane?"
                    header="Potwierdzenie"
                    acceptLabel="Tak"
                    rejectLabel="Nie"
                    accept={() => completeReplacementRequest({replacementRequestId: row.id})}
                />
            </div>
        </>
    );
};

const newListActionTemplate = (row: any) => <Actions row={row}/>;
export default newListActionTemplate;
